'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitButtonWithValidation, TextInput } from '@pioz/mlm-skeleton/form-fields';
import { DisableTwoFaSchema, disableTwoFaSchema } from './disable-two-fa-schema';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useRouter } from 'next/navigation';
import Form from 'next/form';
import { CommonLocals } from '@pioz/mlm-common';

export function DeactivateTwoFaForm({
  locale,
  deactivateAction,
  titleClass,
  t,
  errorsT,
}: {
  locale: CommonLocals;
  deactivateAction: (data: FormData) => Promise<void>;
  titleClass?: string;
  t: {
    title: string;
    pin: string;
    submit: string;
    disablehint: string;
    disabled: string;
    disabledError: string;
  };
  errorsT: {
    required: string;
    incorrectPin: string;
  };
}) {
  const { refresh } = useRouter();

  const {
    trigger,
    register,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm<DisableTwoFaSchema>({
    defaultValues: {
      pin: '',
    },
    mode: 'all',
    resolver: zodResolver(disableTwoFaSchema(errorsT)),
  });

  return (
    <div className="flex h-full flex-col gap-3">
      <h2 className={titleClass}>{t.title}</h2>
      <span>{t.disablehint}</span>
      <Form
        action={async (data) => {
          try {
            await deactivateAction(data);
            toast.success(t.disabled);
          } catch (e) {
            toast.error(t.disabledError);
          } finally {
            reset();
            refresh();
          }
        }}
        className="flex h-full flex-col gap-3"
      >
        <TextInput {...register('pin')} label={t.pin} error={errors.pin} />
        <div className="mt-auto flex justify-end gap-3">
          <SubmitButtonWithValidation
            locale={locale}
            className="btn btn-primary"
            isValid={isValid}
            isDirty={isDirty}
            trigger={trigger}
          >
            {t.submit}
          </SubmitButtonWithValidation>
        </div>
      </Form>
    </div>
  );
}
